import { useState, useEffect } from 'react';
import axios from 'axios';

interface ExchangeRates {
    [key: string]: number;
}

export const useCurrency = () => {
    const [rates, setRates] = useState<ExchangeRates>({});
    const [loading, setLoading] = useState(true);
    const [selectedCurrency, setSelectedCurrency] = useState(localStorage.getItem('user-currency') || 'USD');

    const fetchRates = async () => {
        try {
            const response = await axios.get('/api/financial/exchange-rates');
            if (response.data.success) {
                setRates(response.data.rates);
            }
        } catch (error) {
            console.error('Failed to fetch exchange rates:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRates();

        const handleCurrencyChange = () => {
            setSelectedCurrency(localStorage.getItem('user-currency') || 'USD');
        };

        window.addEventListener('currencyChange', handleCurrencyChange);
        return () => window.removeEventListener('currencyChange', handleCurrencyChange);
    }, []);

    const formatPrice = (amountUsd: number) => {
        const rate = rates[selectedCurrency] || 1;
        const converted = amountUsd * rate;
        
        // Custom formatting for specific currencies like ZiG
        if (selectedCurrency === 'ZiG') {
            return `ZiG ${converted.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }

        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: selectedCurrency,
        }).format(converted);
    };

    return {
        selectedCurrency,
        formatPrice,
        loading,
        rates
    };
};
